export const AUTH_CONSTANTS = {
  DEFAULT_USER_GROUP: import.meta.env.VITE_DEFAULT_USER_GROUP || "CES_USER",
  PASSWORD_CHANGE_STEP: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  LOADING_DELAY: 1000,
  DEFAULT_REDIRECT_PATH: "/",
  LOGIN_PATH: "/login",
};

export const AUTH_MESSAGES = {
  SIGNING_IN: "Signing In...",
  CHANGING_PASSWORD: "Changing...",
  SIGN_IN: "Sign In",
  CHANGE_PASSWORD: "Change Password",
  ERROR_SIGNING_IN: "Error signing in",
  ERROR_CHANGING_PASSWORD: "Error changing password",
  PASSWORD_CHANGE_REQUIRED: "You must change your password to continue",
};

export const AUTH_LABELS = {
  USERNAME: "Username",
  PASSWORD: "Password",
  NEW_PASSWORD: "New Password",
  NEW_PASSWORD_PLACEHOLDER: "Enter your new password",
};
